define('SageDotCom/DataLayer/Events/scroll',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function ScrollEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'scroll'; // overwrite name
    }

    ScrollEvent.prototype = Object.create(EventBase.prototype);

    ScrollEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scrollPoint) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "1", //non interaction point
            "event_category": "component", //top line category
            "event_action": this.getName(), //specific action
            'event_label': '' + scrollPoint + '%', // convert to string
            'event_name_level_1': '',
            'event_name_level_2': '',
            'event_name_level_3': '',
            'event_name_level_4': ''

        }
        return eventData;
    }

    return new ScrollEvent();
});
